import type { AutocompleteResult } from './types';

export function mapPrediction(
  fromGooglePrediction: google.maps.places.AutocompletePrediction
): AutocompleteResult {
  return {
    id: fromGooglePrediction.place_id,
    description: fromGooglePrediction.description,
  };
}
